// Phase 7 — Hot New (admin) screen, migrated to shadcn/Tailwind.
//
// UI only: antd Row/Col/Input/Select/Switch/Pagination → shared DataTable + a
// shadcn Select + Switch, with search + status filter in the toolbar slot. Every
// dispatch (getHotNewTopPickAction / updateHotNewTopPickAction) and the effect
// wiring are unchanged, so the payloads stay byte-identical.
import { useEffect, useMemo, useState } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { Search } from "lucide-react";
import ApparelMenu from "./apparelMenu";
import { useDispatch, useSelector } from "react-redux";
import { getHotNewTopPickAction, updateHotNewTopPickAction } from "../../Store/actions/apparelAction";
import AppConstant from "../../Globals/AppConstants";
import { deepCopyFunction } from "../../Utils/helpers";
import { DataTable } from "../../shared/data-table";
import { LoadingOverlay } from "../../shared/loading-overlay";
import { Input } from "ui/input";
import { Switch } from "ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "ui/select";

const IMG_BASE = `${process.env.REACT_APP_AWS_CLOUD_FRONT_URL}/${process.env.REACT_APP_IMAGE_DESTINATION_BUCKET}products/images/`;

let hotNewTemp = {
    searchText: "",
    limit: 10,
    offset: 0,
    sort: 0
}

const HotNew = () => {
    const apparelReducer = useSelector((state: any) => state.ApparelReducerState)
    const { getHotNewTopPickLoad, getHotNewTopPickData, updateHotNewTopPickLoad } = apparelReducer;

    const hotNewData = getHotNewTopPickData?.getHotPicksAndTopNewAdmin?.hotPickAndTopNewData
    const pagingData = getHotNewTopPickData?.getHotPicksAndTopNewAdmin?.page

    const dispatch = useDispatch();
    const [hotNew, setHotNew] = useState<any>(deepCopyFunction(hotNewTemp));
    const [updateHotNewTopPickApiLoad, setUpdateHotNewTopPickApiLoad] = useState(false)
    const [search, setSearch] = useState(false);

    const onChangePagination = (page: any) => {
        setHotNew({ ...hotNew, offset: ((page * 10) - 10 == 0) ? 0 : (page * 10) - 10 })
    }

    const getHotPicksAndTopNewApi = () => {
        let payload = {
            searchText: hotNew?.searchText,
            hotNewSort: hotNew?.sort,
            topPickSort: AppConstant?.zero,
            paging: {
                limit: hotNew?.limit,
                offset: hotNew?.offset
            }
        }
        dispatch(getHotNewTopPickAction(payload))
    }

    const updateHotNewTopPickApi = (hotNew: any, productDetailId: any, productItemId: any) => {
        let payload = {
            productDetailId: productDetailId,
            productItemId: productItemId,
            hotNew: hotNew,
            topPick: AppConstant.zero
        }
        dispatch(updateHotNewTopPickAction(payload))
        setUpdateHotNewTopPickApiLoad(true)
    }

    useEffect(() => {
        if (hotNew) {
            getHotPicksAndTopNewApi();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hotNew]);

    useEffect(() => {
        if (!updateHotNewTopPickLoad && updateHotNewTopPickApiLoad) {
            getHotPicksAndTopNewApi();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateHotNewTopPickApiLoad, updateHotNewTopPickLoad])

    useEffect(() => {
        if (search) {
            const getData = setTimeout(() => {
                getHotPicksAndTopNewApi()
            }, 500)
            setSearch(false)
            return () => clearTimeout(getData)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hotNew?.searchText])

    const setHotNewData = (value: any) => {
        updateHotNewTopPickApi(value?.hotNew == 0 ? 1 : 0, value?.productDetailId, value?.productItemId)
    }

    const searchTextApi: any = (e: any) => {
        setSearch(true)
        setHotNew({
            ...hotNew,
            searchText: e?.target?.value
        })
    }

    const columns = useMemo<ColumnDef<any, any>[]>(
        () => [
            {
                id: "name",
                header: "Name",
                cell: ({ row }) => (
                    <div className="flex items-center gap-3">
                        {row.original?.attachmentId
                            ? <img src={`${IMG_BASE}${row.original?.attachmentId}`} className="h-12 w-12 rounded-md object-cover" alt="" />
                            : <span className="text-muted-foreground">-</span>}
                        <span>{row.original?.productName}</span>
                    </div>
                ),
            },
            { id: "productId", header: "ProductId", cell: ({ row }) => row.original?.productId },
            {
                id: "status",
                header: "Status",
                cell: ({ row }) => (
                    <Switch checked={!!row.original?.hotNew} onCheckedChange={() => setHotNewData(row.original)} />
                ),
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [hotNew]
    );

    const toolbar = (
        <div className="flex flex-wrap items-center gap-2">
            <div className="relative w-full sm:w-[280px]">
                <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                <Input className="pl-9" placeholder="Search by productName/ productId" onChange={(e: any) => searchTextApi(e)} />
            </div>
            <Select defaultValue="0" onValueChange={(v) => setHotNew({ ...hotNew, sort: v })}>
                <SelectTrigger className="w-[150px]"><SelectValue placeholder="Status" /></SelectTrigger>
                <SelectContent>
                    <SelectItem value="0">All</SelectItem>
                    <SelectItem value="1">Selected</SelectItem>
                </SelectContent>
            </Select>
        </div>
    );

    return (
        <div className="mz h-full overflow-y-auto px-6 py-4">
            <ApparelMenu selectedKey="11" />
            <DataTable
                columns={columns}
                data={hotNewData || []}
                loading={getHotNewTopPickLoad}
                toolbar={toolbar}
                title={AppConstant.HOTNEW}
                pagination={{
                    page: pagingData?.currentPage || 1,
                    total: pagingData?.totalCount || 0,
                    onChange: onChangePagination,
                }}
            />
            <LoadingOverlay loading={getHotNewTopPickLoad || updateHotNewTopPickLoad} />
        </div>
    )
}

export default HotNew;
